import { _firestore } from '../../firebase';
import ActionTypes from './constants';

import {
  getCurrentFormattedMomentDate,
  getCurrentTimestamp,
} from '../../helpers/timeHelper';
import { selectStoreConfig } from '../Layout/selectors';

export function updateReservation(reservation, status) {
  return (dispatch, getState) => {
    const storeConfig = selectStoreConfig(getState());
    let requestObj = {
      reservationId: reservation._id,
      reservationStatus: status,
      date: getCurrentFormattedMomentDate(
        storeConfig.timeZone,
        'YYYY-MM-DD HH:mm'
      ),
      dateTimestamp: getCurrentTimestamp(),
    };
    fetch(`${storeConfig.cloudFunctionsUrl}/confirmReservation`, {
      method: 'post',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...requestObj,
      }),
    })
      .then((res) => res.json())
      .then((_result) => {
        dispatch(reservationUpdated(true));
      });
  };
}

export function fetchReservation(reservationId) {
  return (dispatch) => {
    let docRef = _firestore.collection('Reservations').doc(reservationId);
    docRef.onSnapshot((doc) => {
      let obj = { _id: doc.id, ...doc.data() };
      dispatch(reservationfetched(obj));
    });
  };
}

function reservationfetched(reservation) {
  return {
    type: ActionTypes.FetchReservation,
    reservation,
  };
}

function reservationUpdated(isReservationUpdated) {
  return {
    type: ActionTypes.UpdateReservation,
    isReservationUpdated,
  };
}
